const registerComponents = (Vue, prefix, components) => {
  for (let key in components) {
    Vue.component(prefix + key, components[key]);
  }
};

export { registerComponents };
